export default {
  neck_brace_method: "",
  renew: "",
  type: "PLASTER_NECK_BRACE",
  chest: "",
  idc_sagging_chest: false,

  idc_exterior_finishing: false,
  exterior_finishing_type: null,
  transfer_id: null,
  thickness_external_finish: null,
  other_external_finish: null,

  idc_interior_finishing: false,
  interior_finishing_type: null,
  thickness_internal_finish: null,
  other_internal_finish: null,

  comment: "",
  body_measures: {
    1: {
      a1: null,
      b1: null,
      e1: null,
      f1: null
    },
    2: {
      a2: null,
      b2: null,
      e2: null,
      f2: null
    },
    3: {
      a3: null,
      b3: null,
      e3: null,
      f3: null
    },
    4: {
      a4: null,
      b4: null,
      e4: null,
      f4: null
    },
    5: {
      a5: null,
      c5: null,
      d5: null,
      e5: null,
      f5: null
    },
    6: {
      a6: null,
      c6: null,
      d6: null,
      e6: null,
      f6: null
    },
    7: {
      a7: null,
      c7: null,
      d7: null,
      e7: null,
      f7: null
    },
    8: {
      a8: null,
      c8: null,
      d8: null,
      e8: null
    },
    9: {
      a9: null,
      c9: null,
      d9: null,
      e9: null,
      f9: null
    },
    10: {
      a10: null,
      c10: null,
      d10: null,
      e10: null,
      f10: null
    },
    11: {
      a11: null,
      c11: null,
      d11: null,
      e11: null,
      f11: null
    },
    g: null,
    i: null,
    j: null,
    k: null,
    l: null
  },
  part_to_order: "",
  idc_tr25n35: false,
  idc_tr27o12: false,
  idc_tr24n35: false,
  idc_t26p01: false,
  idc_t29p01: false,
  other_lpr: "",
  articles: []
};
